export default __webpack_public_path__ + "static/media/Facebook_Color.7b825454.svg";